export default "__VITE_ASSET__a1d1f6f7__"